/**
 * Created by PJPERF on 05.04.2017.
 */
import React from 'react'
import Toggle from 'react-toggle'
import Field from './field_class';


class ToggleField extends Field{
    getWrapClassName() {
        return "toggle field_wrap " + this.getNamePostfix();
    }
    onChange(event) {
        if (this.props.params) {
            this.props.onChange({name: this.props.name, value: event.target.checked, params: this.props.params})
        } else {
            this.props.onChange({name: this.props.name, value: event.target.checked})
        }
    }
    showInput() {
        let checked_value = (this.props.value) ? true : false;
        return (
            <Toggle
                //defaultChecked={checked_value}
                checked={checked_value}
                id={this.getNamePostfix()} value={"1"} name={this.getNamePostfix()}
                onChange={this.onChange.bind(this)}
                disabled={this.isDisabled()}/>
        )
    }
    render() {
        if (this.isHidden()) {
            return null
        } else {
            return (
                <div className={this.getWrapClassName()}>
                    {this.showInput()}
                    {this.showLabel()}
                    {this.showError()}
                </div>
            )
        }
    }
}

export default ToggleField;